// @ts-ignore
import React from 'react'
import Swap from '../Swap'

export default function Trade() {
  return <Swap />
}
